var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZnn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.473 7H8.5V8.58957H13.5811L8.52703 11.6879V19.6897H9.93243V15.7022L15.0676 19.6627H16.5V18.8545V18.7197V11.9304H11.1757L16.5 8.53569V7H16.473ZM15.0135 13.4661L15.0405 17.5612L9.90541 13.4661H15.0135V13.4661Z",
    fill: "url(#paint0_linear_87_465)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_465",
    x1: 12.5,
    y1: 7,
    x2: 12.5,
    y2: 19.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40BF21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZnn);
export default __webpack_public_path__ + "static/media/znn.45566afe905c1ee08cbd48a66c646981.svg";
export { ForwardRef as ReactComponent };